import React from "react";
import { Inicio } from "./components/inicio";
import { Sobre } from "./components/sobre";
import { Depoimento } from "./components/depoimento";
import { Funcionalidade } from "./components/funcionalidade";
import { Duvidas } from "./components/duvidas";
import { Footer } from "./components/footer";
import { BgImag } from "./components/bgImag";
import { Anilhas } from "./components/anilhas";
import { Tabela } from "./components/tabela";

export default function AnilhasPage() {
  return (
    <main className="bg-gray-100 text-neutral-900 font-sans scroll-smooth relative w-full overflow-x-hidden">
      <BgImag />
      <div className="mx-auto px-4 max-w-7xl ">
        <Inicio />
        <Anilhas />
        <Tabela />
        <Sobre />
        <Depoimento />
        <Funcionalidade />
        <Duvidas />
        <Footer />
      </div>

      <a
        href="https://wa.me/5547999320627?text=ver%20modelos%20de%20anilhas"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-2 sm:left-auto sm:right-4 md:right-10 top-1/2 -translate-y-1/2 z-50"
      >
        <img
          src="/img/whats-app.png"
          alt="WhatsApp Mobile"
          className="block sm:hidden w-20 transition-all duration-300 ease-in-out"
        />
        <img
          src="/img/whats.png"
          alt="WhatsApp Desktop"
          className="hidden sm:block w-28 md:w-32 lg:w-36 transition-all duration-300 ease-in-out"
        />
      </a>
    </main>
  );
}
